// Deep-link parsing + routing for `leadctrl://...` custom scheme and
// `https://leads.caterctrl.co.uk/*` universal links. Logged-out users get bounced to login
// with the intended path stored, then resumed. Server RBAC re-checks on the detail fetch.
import { App as CapApp } from "@capacitor/app";
import { isNative } from "@/native/capacitor";

const PENDING_KEY = "leadctrl_pending_deeplink";
const UNIVERSAL_HOST = "leads.caterctrl.co.uk";

export function parsePath(url) {
  if (!url) return null;
  try {
    if (url.startsWith("leadctrl://")) {
      const rest = url.slice("leadctrl://".length);
      return ("/" + rest.replace(/^\/+/, "")).replace(/\/+$/, "") || "/today";
    }
    const u = new URL(url);
    if (u.hostname && u.hostname !== UNIVERSAL_HOST) return null;
    return (u.pathname + u.search) || "/today";
  } catch {
    return null;
  }
}

export function storePendingDeepLink(path) {
  try { if (path) sessionStorage.setItem(PENDING_KEY, path); } catch { /* ignore */ }
}
export function popPendingDeepLink() {
  try {
    const p = sessionStorage.getItem(PENDING_KEY);
    sessionStorage.removeItem(PENDING_KEY);
    return p;
  } catch { return null; }
}

export async function initDeepLinks(navigate) {
  if (!isNative()) return;
  await CapApp.addListener("appUrlOpen", (event) => {
    const path = parsePath(event?.url);
    if (path) navigate(path);
  });
}
